import { render, staticRenderFns } from "./AS_TenderArchive.vue?vue&type=template&id=2761b385&scoped=true&"
import script from "./AS_TenderArchive.vue?vue&type=script&lang=js&"
export * from "./AS_TenderArchive.vue?vue&type=script&lang=js&"
import style0 from "./AS_TenderArchive.vue?vue&type=style&index=0&id=2761b385&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2761b385",
  null
  
)

export default component.exports